export class Sleep {
    public async sleep(timeout?: number) {
        if (!timeout) return;
        return new Promise((resolve, reject) => {
            setTimeout(() => resolve(), timeout);
        });
    }
}


// WEBPACK FOOTER //
// ./src/app/services/sleep.ts